<ul id="slide-out" class="sidenav sidenav-custom">
    <li>
        <div class="user-view">
            <div class="background">
                <img src="assets/logoDelphus.jpeg" width="220">
            </div>
        </div>
    </li>
    <li><a routerLink="/galpones" (click)="closeSidebar('Galpones')"><i class="fa fa-home"></i>Galpones</a></li>
    <li><a *ngIf="current == 'pesajes' || current == 'corrales'" (click)="goLotes()"><i class="fa fa-institution"></i>Lotes</a></li>
    <li><a *ngIf="current == 'pesajes'" (click)="goCorrales()"><i class="fa fa-briefcase"></i>Corrales</a></li>
    <li><div class="divider"></div></li>
    <li><a [ngClass]="wifi"><i class="fa fa-{{ wifi_icon }}"></i>{{ status }}</a></li>
    <li class="li-supergen">
        <p>FE: {{versionFE}}</p>
        <img src="assets/logo-supergen.png" width="100">
        <p>BE: {{versionBE}}</p>
    </li>
    <li class="btnLogout">
        <div class="divider"></div>
        <a (click)="logout()" class="cabecera white-text">
            <i class="fa fa-sign-out cabecera white-text"></i>Cerrar Sesión
        </a>
    </li>
</ul>
<a class="internet" [ngClass]="wifi"><i class="fa fa-{{ wifi_icon }}"></i></a>

<!-- Modal Structure -->
<div id="modal3" class="modal">
    <div class="modal-content">
        <h4>{{ alert_message }}</h4>
    </div>
    <div class="modal-footer">
        <a class="modal-close waves-effect waves-green btn-flat confirmar" (click)="confirmar()">Confirmar</a>
        <a class="modal-close waves-effect waves-green btn-flat" (click)="close()">Cerrar</a>
    </div>
</div>
<router-outlet></router-outlet>
